import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PageHeader from "../../../Components/PageHeader";
import api from "../../../Utils/api";
import { formatDate } from "../../../Utils/helpers";
import { setLoading } from "../../../store/reducer/loading";
import { updateMessage } from "../../../store/reducer/message";

const Message = () => {
  const utilisateurs = useSelector((state) => state.user);
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const { id } = useParams();

  const reader = (auth, message, users) => {
    const [reader] = users.filter((user) => user.id === message.readerId);
    // console.log(reader);
    return reader?.id === auth?.id
      ? "moi"
      : `${
          reader?.firstname.split(" ")[0].charAt(0).toUpperCase() +
          reader?.firstname.split(" ")[0].slice(1)
        }   ${reader?.lastname.toUpperCase()}`;
  };

  document.title = "DashBoard | Message";
  useEffect(() => {
    const loadMessage = async (id) => {
      dispatch(setLoading(true));
      try {
        const { data } = await api.get(`message/${id}`);
        let message = data.message;

        if (!message?.readAt || !message?.readerId) {
          const updatedMessage = { ...message, readerId: auth.id };
          try {
            const response = await api.put(`message/${id}`, updatedMessage);
            if (response.data.message) {
              dispatch(updateMessage(response.data.message));
              message = {
                ...message,
                readerId: response.data.message?.readerId,
              };
            }
          } catch (error) {
            if (error.response.status === 401) {
              navigate("/login");
            }
          }
        }
        setMessage(message);
      } catch (error) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      } finally {
        dispatch(setLoading(false));
      }
    };
    loadMessage(id);
  }, [id]);

  return (
    <>
      <PageHeader page="Détails Message" />

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header"></div>
            <div className="card-body">
              {message && (
                <form className="form-horizontal">
                  <div className="row">
                    <label
                      htmlFor="lbl"
                      className="col-sm-12 col-form-label text-info d-flex justify-content-end"
                    >
                      Reçu le : {formatDate(message.createdAt, true)}
                    </label>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="lbl"
                      className="col-sm-12 col-form-label text-info d-flex justify-content-end"
                    >
                      Lu le :
                      {message.readAt
                        ? formatDate(message.readAt, true)
                        : formatDate(new Date(), true)}{" "}
                      par : {reader(auth, message, utilisateurs)}
                    </label>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="name" className="col-sm-2 col-form-label">
                      Nom
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        defaultValue={message.nom}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="email" className="col-sm-2 col-form-label">
                      Email
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        defaultValue={message.email}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="contact"
                      className="col-sm-2 col-form-label"
                    >
                      Contact
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="contact"
                        defaultValue={message.contact}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="link" className="col-sm-2 col-form-label">
                      Sujet
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="sujet"
                        defaultValue={message.sujet}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label htmlFor="desc" className="col-sm-2 col-form-label">
                      Message
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        rows="5"
                        id="message"
                        defaultValue={message.message}
                        readOnly
                      ></textarea>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="offset-sm-2 col-sm-10">
                      <button
                        type="submit"
                        className="btn btn-info"
                        onClick={() => navigate("/messages")}
                      >
                        Retour
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
      {/* /.content */}
    </>
  );
};

export default Message;
